module.exports = __webpack_public_path__ + "static/careDemo3-aa9f8f3422ef23f916357c31e89a4f1b.svg";